import React, { useState, useEffect } from 'react';
import API from '../utils/api';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import toast from 'react-hot-toast';

const TIPO_CONFIG = {
  info:    { bg:'#EFF6FF', color:'#1D4ED8', icon:'ℹ️' },
  alerta:  { bg:'#FEF3C7', color:'#92400E', icon:'⚠️' },
  error:   { bg:'#FEF2F2', color:'#991B1B', icon:'🚨' },
  success: { bg:'#F0FDF4', color:'#065F46', icon:'✅' },
};

export default function Notificaciones() {
  const [notifs, setNotifs] = useState([]);
  const [cargando, setCargando] = useState(true);

  const cargar = () => {
    API.get('/app/notificaciones')
      .then(r => { setNotifs(r.data); setCargando(false); })
      .catch(() => setCargando(false));
  };

  useEffect(() => { cargar(); }, []);

  const marcarLeida = async (id) => {
    await API.put(`/app/notificaciones/${id}/leer`).catch(() => {});
    setNotifs(ns => ns.map(n => n.id === id ? { ...n, leida: true } : n));
  };

  const marcarTodas = async () => {
    await API.put('/app/notificaciones/leer-todas').catch(() => {});
    setNotifs(ns => ns.map(n => ({ ...n, leida: true })));
    toast.success('Todas marcadas como leídas');
  };

  const noLeidas = notifs.filter(n => !n.leida).length;

  if (cargando) return <div style={{ textAlign:'center', padding:40, color:'#9CA3AF' }}>Cargando...</div>;

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
        <div>
          <h1 style={{ margin:0, fontSize:20, fontWeight:800, color:'#111827' }}>🔔 Alertas</h1>
          {noLeidas > 0 && <div style={{ fontSize:12, color:'#6B7280', marginTop:2 }}>{noLeidas} sin leer</div>}
        </div>
        {noLeidas > 0 && (
          <button onClick={marcarTodas}
            style={{ background:'#F3F4F6', border:'none', borderRadius:8, padding:'6px 12px', fontSize:12, fontWeight:600, cursor:'pointer', color:'#374151' }}>
            ✓ Leer todas
          </button>
        )}
      </div>

      {notifs.length === 0 ? (
        <div style={{ textAlign:'center', padding:'60px 20px', color:'#9CA3AF' }}>
          <div style={{ fontSize:48, marginBottom:12 }}>🔕</div>
          <div style={{ fontWeight:600, fontSize:15 }}>Sin notificaciones</div>
          <div style={{ fontSize:13, marginTop:4 }}>Las alertas del sistema aparecerán aquí</div>
        </div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
          {notifs.map(n => {
            const cfg = TIPO_CONFIG[n.tipo] || TIPO_CONFIG.info;
            return (
              <div key={n.id} onClick={() => !n.leida && marcarLeida(n.id)}
                style={{ background:'white', borderRadius:12, padding:'14px 16px', boxShadow:'0 1px 3px rgba(0,0,0,0.07)', cursor: n.leida?'default':'pointer', borderLeft:`4px solid ${cfg.color}`, opacity: n.leida?0.65:1 }}>
                <div style={{ display:'flex', gap:10, alignItems:'flex-start' }}>
                  <span style={{ fontSize:18, flexShrink:0 }}>{cfg.icon}</span>
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight: n.leida?500:700, fontSize:14, color:'#111827', marginBottom:3 }}>{n.titulo}</div>
                    <div style={{ fontSize:13, color:'#4B5563', lineHeight:1.5 }}>{n.cuerpo}</div>
                    <div style={{ fontSize:11, color:'#9CA3AF', marginTop:6 }}>
                      {format(new Date(n.created_at), "d 'de' MMMM · HH:mm", { locale: es })}
                      {!n.leida && <span style={{ marginLeft:8, color:cfg.color, fontWeight:700 }}>● Nueva</span>}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
